import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';

const campaigns = accountId => ({
  parentNav: 'campaigns',
  routes: ['campaigns_whatsapp_index'],
  menuItems: [
    {
      key: 'whatsappCampaigns',
      icon: 'sound-source',
      label: 'WHATSAPP',
      hasSubMenu: false,
      featureFlag: FEATURE_FLAGS.WHATSAPP_CAMPAIGNS,
      toState: frontendURL(`accounts/${accountId}/campaigns`),
      toStateName: 'campaigns_whatsapp_index',
    },
  ],
});

export default campaigns;
